import { render, staticRenderFns } from "./Invoicexq.vue?vue&type=template&id=2eab3683&scoped=true&"
import script from "./Invoicexq.vue?vue&type=script&lang=js&"
export * from "./Invoicexq.vue?vue&type=script&lang=js&"
import style0 from "./Invoicexq.vue?vue&type=style&index=0&id=2eab3683&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eab3683",
  null
  
)

export default component.exports